import {Component, ViewChild} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {GoogleMapsComponent} from "../../components/google-maps/google-maps";
import {ShopPage} from "../shop/shop";

/**
 * Generated class for the DiscoveryFeedMapPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-discovery-feed-map',
    templateUrl: 'discovery-feed-map.html',
})
export class DiscoveryFeedMapPage {
    @ViewChild(GoogleMapsComponent) mapComponent: GoogleMapsComponent;

    shops: any;
    latLng: any;
    fullScreen: boolean;
    updateShopsOnMove: boolean = true;

    constructor(public navCtrl: NavController, public navParams: NavParams) {
        this.shops = navParams.get('shops');
        this.latLng = navParams.get('latLng');
        this.fullScreen = navParams.get('fullScreen');
        this.updateShopsOnMove = navParams.get('updateShopsOnMove');
    }

    public ionViewDidEnter(): void {
        this.navCtrl.swipeBackEnabled = false;
    }

    public ionViewDidLeave(): void {
        this.navCtrl.swipeBackEnabled = true;
    }

    openPage(event: any, shop: object) {
        this.navCtrl.push(ShopPage, {
            shop: shop
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/discovery-feed-map/discovery-feed-map.ts